export default "__VITE_ASSET__Cax6_z$C__"